import ApiClient from '@api'

export default {
  install(Vue) {
    Vue.prototype.$http = ApiClient
  },
}
